import { render, staticRenderFns } from "./editPsInfo.vue?vue&type=template&id=2a915d70&scoped=true"
import script from "./editPsInfo.vue?vue&type=script&lang=js"
export * from "./editPsInfo.vue?vue&type=script&lang=js"
import style0 from "./editPsInfo.vue?vue&type=style&index=0&id=2a915d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a915d70",
  null
  
)

export default component.exports